import React from 'react';
import { Button, Form, Input, Switch } from 'antd';

import type { PartnerProgramFaqFormValue } from '../types/partnerProgramFaq';

const { TextArea } = Input;

const wideFormItemProps = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
  labelAlign: 'left' as const,
};

const fieldGroupStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
};

const inlineRowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
};

const textAreaStyle = { width: '100%', minHeight: 100 };
const addButtonStyle = { color: '#637f92', fontWeight: 600 };

const visibleStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  color: '#333',
  whiteSpace: 'nowrap',
};

function createEmptyFaq(): PartnerProgramFaqFormValue {
  return {
    id: `custom-${Date.now()}`,
    question: '',
    answer: '',
    isActive: true,
  };
}

const PartnerProgramFaqsEditor: React.FC = () => {
  return (
    <Form.List name="partnerProgramFaqs">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => (
            <Form.Item key={field.key} label={`FAQ ${index + 1}`} {...wideFormItemProps} required>
              <Form.Item name={[field.name, 'id']} style={{ display: 'none' }} hidden>
                <Input />
              </Form.Item>

              <div style={{ ...fieldGroupStyle, width: '100%' }}>
                <div style={inlineRowStyle}>
                  <Form.Item
                    {...field}
                    name={[field.name, 'question']}
                    rules={[{ required: true, message: 'Question is required' }]}
                    style={{ flex: 1, marginBottom: 0 }}
                  >
                    <Input placeholder="FAQ Question" />
                  </Form.Item>
                  <div style={visibleStyle}>
                    <span>Visible:</span>
                    <Form.Item
                      {...field}
                      name={[field.name, 'isActive']}
                      valuePropName="checked"
                      style={{ marginBottom: 0 }}
                    >
                      <Switch />
                    </Form.Item>
                  </div>
                  <Button danger onClick={() => remove(field.name)}>
                    Remove
                  </Button>
                </div>
                <Form.Item
                  {...field}
                  name={[field.name, 'answer']}
                  rules={[{ required: true, message: 'Answer is required' }]}
                  style={{ marginBottom: 0 }}
                >
                  <TextArea rows={3} placeholder="FAQ Answer" style={textAreaStyle} />
                </Form.Item>
              </div>
            </Form.Item>
          ))}

          <Form.Item wrapperCol={{ span: 12, offset: 4 }}>
            <Button type="dashed" onClick={() => add(createEmptyFaq())} style={addButtonStyle}>
              {fields.length === 0 ? '+ Add First FAQ' : '+ Add FAQ'}
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};

export default PartnerProgramFaqsEditor;
